// update along with app/lib/enums/product_list_filter.py
const ProductListFilter = {
  MANUFACTURER_IDS: 'manufacturer_ids',
  DISTRIBUTOR_IDS: 'distributor_ids',
  BRAND_IDS: 'brand_ids',
  STATUS: 'status',
  CND_SYNC_STATUS: 'cnd_sync_status',
  CND_ACTIVE_STATUS: 'cnd_active_status',
  CLASSIFICATION_STATUS: 'classification_status',
  VERIFICATION_STATUS: 'verification_status',
  SYSTEM_STATUS: 'system_status',
  UPB_MATCH_STATUS: 'upb_match_status',
};

export default ProductListFilter;
